const initialState = {
  templatePermissions: {},
  templateLists: [],
  templateById: null,
  templateScanResult: null,
  templateComboCheck: null,
  templateAssociations: null,
  templateActivityLogs: [],
  templateCount: 0,
  templateReportForm: null,
  changedTemplateStatus: [],
  loadingTemplate: false,
  loadingTemplateReportForm: false,
  loadingTemplateLogs: false,
  loadingTemplateComboCheck: false,
  loadingTemplateAssociations: false,
  errorsTemplate: {},
};

const templateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TEMPLATELIST_PENDING":
    case "GET_TEMPLATELISTBYID_PENDING":
    case "ADD_TEMPLATE_PENDING":
    case "UPDATE_TEMPLATE_PENDING":
    case "UPDATE_TEMPLATE_STATUS_PENDING":
    case "DELETE_TEMPLATE_PENDING":
    case "SCAN_TEMPLATE_PENDING":
      return { ...state, loadingTemplate: true };

    case "CHECK_TEMPLATE_COMBO_PENDING":
      return {
        ...state,
        loadingTemplateComboCheck: true,
        errorsTemplate: {},
      };

    case "GET_TEMPLATE_ACTIVITY_LOGS_PENDING":
      return { ...state, loadingTemplateLogs: true };

    case "GET_TEMPLATE_ASSOCIATIONS_PENDING":
    case "ADD_TEMPLATE_ASSOCIATIONS_PENDING":
    case "DELETE_TEMPLATE_ASSOCIATION_PENDING":
      return {
        ...state,
        loadingTemplateAssociations: true,
        errorsTemplate: {},
      };

    case "GET_TEMPLATE_REPORT_FORM_PENDING":
      return {
        ...state,
        loadingTemplateReportForm: true,
        errorsTemplate: {},
      };

    case "GET_TEMPLATELIST_FULFILLED":
      return {
        ...state,
        loadingTemplate: false,
        templateLists: action.payload,
        templateCount: action.templateCount,
        templatePermissions: action.permissions,
        errorsTemplate: {},
      };

    case "GET_TEMPLATELISTBYID_FULFILLED":
      return {
        ...state,
        loadingTemplate: false,
        templateById: action.payload,
        errorsTemplate: {},
      };

    case "CHECK_TEMPLATE_COMBO_FULFILLED":
      return {
        ...state,
        loadingTemplateComboCheck: false,
        templateComboCheck: action.payload,
        errorsTemplate: {},
      };

    case "SCAN_TEMPLATE_FULFILLED":
      return {
        ...state,
        loadingTemplate: false,
        templateScanResult: action.payload,
        errorsTemplate: {},
      };

    case "GET_TEMPLATE_ACTIVITY_LOGS_FULFILLED":
      return {
        ...state,
        loadingTemplateLogs: false,
        templateActivityLogs: action.payload,
        errorsTemplate: {},
      };

    case "GET_TEMPLATE_ASSOCIATIONS_FULFILLED":
    case "ADD_TEMPLATE_ASSOCIATIONS_FULFILLED":
    case "DELETE_TEMPLATE_ASSOCIATION_FULFILLED":
      return {
        ...state,
        loadingTemplateAssociations: false,
        templateAssociations: action.payload,
        errorsTemplate: {},
      };

    case "GET_TEMPLATE_REPORT_FORM_FULFILLED":
      return {
        ...state,
        loadingTemplateReportForm: false,
        templateReportForm: action.payload,
        errorsTemplate: {},
      };

    case "ADD_TEMPLATE_FULFILLED":
    case "UPDATE_TEMPLATE_FULFILLED":
    case "UPDATE_TEMPLATE_STATUS_FULFILLED":
    case "DELETE_TEMPLATE_FULFILLED":
      return {
        ...state,
        loadingTemplate: false,
        changedTemplateStatus: action.payload,
        errorsTemplate: {},
      };

    case "RESET_TEMPLATE_STATUS":
      return {
        ...state,
        loadingTemplate: false,
        loadingTemplateLogs: false,
        loadingTemplateComboCheck: false,
        loadingTemplateAssociations: false,
        loadingTemplateReportForm: false,
        changedTemplateStatus: [],
        templateScanResult: null,
        templateComboCheck: null,
        templateAssociations: null,
        templateActivityLogs: [],
        templateReportForm: null,
        errorsTemplate: {},
      };

    case "RESET_TEMPLATE_REPORT_FORM":
      return {
        ...state,
        loadingTemplateReportForm: false,
        templateReportForm: null,
        errorsTemplate: {},
      };

    case "GET_TEMPLATELIST_REJECTED":
    case "GET_TEMPLATELISTBYID_REJECTED":
    case "ADD_TEMPLATE_REJECTED":
    case "UPDATE_TEMPLATE_REJECTED":
    case "UPDATE_TEMPLATE_STATUS_REJECTED":
    case "DELETE_TEMPLATE_REJECTED":
    case "SCAN_TEMPLATE_REJECTED":
      return {
        ...state,
        loadingTemplate: false,
        errorsTemplate: action.payload,
      };

    case "CHECK_TEMPLATE_COMBO_REJECTED":
      return {
        ...state,
        loadingTemplateComboCheck: false,
        templateComboCheck: null,
        errorsTemplate: action.payload,
      };

    case "GET_TEMPLATE_ACTIVITY_LOGS_REJECTED":
      return {
        ...state,
        loadingTemplateLogs: false,
        templateActivityLogs: [],
        errorsTemplate: action.payload,
      };

    case "GET_TEMPLATE_ASSOCIATIONS_REJECTED":
    case "ADD_TEMPLATE_ASSOCIATIONS_REJECTED":
    case "DELETE_TEMPLATE_ASSOCIATION_REJECTED":
      return {
        ...state,
        loadingTemplateAssociations: false,
        errorsTemplate: action.payload,
      };

    case "GET_TEMPLATE_REPORT_FORM_REJECTED":
      return {
        ...state,
        loadingTemplateReportForm: false,
        templateReportForm: null,
        errorsTemplate: action.payload,
      };

    default:
      return state;
  }
};

export default templateReducer;
